import React, { useEffect } from 'react';
import { marked } from 'marked';

const ChatWidget = () => {
  useEffect(() => {
    const config = {
      webhookUrl: 'https://priv-n8n.fossone.app/webhook/b3322ba7-176b-4ab5-9c19-f57eb4fae203/chat',
      branding: {
        logoUrl: 'https://fossone.com/wp-content/uploads/2025/05/RHYM-EYE-Logo_rkktrr1eqw4n9rmoyb3o.webp',
        title: 'Rhymtech Technologies',
        subtitle: 'Your Cybersecurity AI Agent',
        iconUrl: 'https://cdn-icons-png.flaticon.com/128/16878/16878411.png',
        headerBackground: 'rgba(35, 75, 191, 0.8)', // Semi-transparent
      },
      welcomeMessage: 'Hi there! You can ask me anything about the latest ECRS Scan Data, and the Executive summary report for your website/app.',
      style: {
        logoSize: '40px',
        userMessageColor: '#E5F6FD',
        botMessageColor: '#F3F4F650', // more transparent
      }
    };

    const container = document.getElementById('chat-widget');

    const bubble = document.createElement('div');
    bubble.className = 'chat-bubble';
    bubble.innerHTML = `<img src="${config.branding.iconUrl}" width="24" /><span>Ask RHYM AI </span>`;
    container.appendChild(bubble);

    const windowEl = document.createElement('div');
    windowEl.className = 'chat-window';
    windowEl.innerHTML = `
      <div class="chat-header" style="background:${config.branding.headerBackground}">
        <img src="${config.branding.logoUrl}" class="chat-header-logo" width="${config.style.logoSize}" height="${config.style.logoSize}" />
        <div>
          <div><strong>${config.branding.title}</strong></div>
          ${config.branding.subtitle ? `<div style="font-size:0.85em">${config.branding.subtitle}</div>` : ''}
        </div>
      </div>
      <div class="chat-body" id="chat-body">
        ${config.welcomeMessage ? `<div class="chat-message bot">${config.welcomeMessage}</div>` : ''}
      </div>
      <div class="chat-input-container">
        <input type="text" class="chat-input" id="chat-input" placeholder="Type your message...">
        <button class="chat-send-btn" id="chat-send-btn">➤</button>
      </div>
    `;
    container.appendChild(windowEl);

    bubble.onclick = () => {
      windowEl.style.display = windowEl.style.display === 'flex' ? 'none' : 'flex';
      windowEl.style.flexDirection = 'column';
    };

    const chatBody = windowEl.querySelector('#chat-body');
    const input = windowEl.querySelector('#chat-input');
    const sendBtn = windowEl.querySelector('#chat-send-btn');

    function addMessage(text, isUser = true) {
      const msg = document.createElement('div');
      msg.className = `chat-message ${isUser ? 'user' : 'bot'}`;
      msg.innerHTML = isUser ? text : marked.parse(text);
      chatBody.appendChild(msg);
      chatBody.scrollTop = chatBody.scrollHeight;
    }

    async function sendMessage() {
      const text = input.value.trim();
      if (!text) return;
      addMessage(text, true);
      input.value = '';

      try {
        const res = await fetch(config.webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ chatInput: text })
        });
        const data = await res.json();
        const reply = data.output || 'Sorry, no response.';
        addMessage(reply, false);
      } catch (err) {
        addMessage('Sorry, something went wrong.', false);
      }
    }

    sendBtn.onclick = sendMessage;
    input.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') sendMessage();
    });

  }, []);

  return <div id="chat-widget" />;
};

export default ChatWidget;
